import Splide from '@splidejs/splide';

(function($, Drupal, once) {
  'use strict';

  Drupal.behaviors.splide = {
    attach: function(context, settings) {
      const newsSplide = document.querySelector('#news-splide');
      if (newsSplide) {
        $(once('news-splide-init', newsSplide)).each(function() {
          function news_slider_init() {
            let news_carousel;
            const windowWidth = window.innerWidth;

            if (windowWidth < 768 && windowWidth > 550) {
              news_carousel = new Splide('#news-splide', {
                type: 'slide',
                rewind: false,
                pagination: false,
                arrows: true,
                perPage: 2,
                gap: '32px'
              });
            }
            else if (windowWidth < 550) {
              news_carousel = new Splide('#news-splide', {
                type: 'slide',
                rewind: false,
                pagination: false,
                arrows: true,
                perPage: 1,
                gap: '32px'
              });
            }
            else if (windowWidth > 768) {
              news_carousel = new Splide('#news-splide', {
                type: 'slide',
                rewind: false,
                pagination: false,
                arrows: true,
                perPage: 3,
                gap: '32px'
              });
            }
            news_carousel.mount();
          }

          // Call slider initializer on screen resize
          window.addEventListener('resize', function() {
            news_slider_init();
          });

          // Initialize slider on page load
          window.onload = function() {
            news_slider_init();
          };
        });
      }
      // Declare variables
      let $spide_carousels_default,
          $splide_settings,
          $splide_breakpoints;

      // Grab all splide carousels
      $spide_carousels_default = $('.splide');

      // Splide initialization
      function create_carousel_default($block, i) {
        // Set ID for each carousel for easy selection
        const $carousel_id = $block.attr('id');

        // Default splide settings, altered based on conditionals below
        $splide_settings = {
          type: 'slide',
          rewind: true,
          pagination: false,
          arrows: true,
          perPage: 3,
          lazyLoad: 'sequential',
          wheel: false
        };

        // Default  breakpoints, altered based on conditionals below
        // Sets how many items per slide BELOW the given breakpoint
        $splide_breakpoints = {
          1200: {
            perPage: 3
          },
          992: {
            perPage: 2
          },
          768: {
            perPage: 1
          }
        };

        if ($block.hasClass('icon-cards')) {
          $splide_settings = {
            type: 'slide',
            rewind: true,
            pagination: false,
            arrows: true,
            perPage: 5,
            lazyLoad: 'sequential',
            wheel: false
          };

          $splide_breakpoints = {
            1200: {
              perPage: 3
            },
            992: {
              perPage: 3
            },
            768: {
              perPage: 1
            }
          };
        }

        if ($block.hasClass('testimonials')) {
          $splide_settings = {
            type: 'slide',
            rewind: true,
            pagination: true,
            arrows: true,
            perPage: 1,
            lazyLoad: 'sequential',
            wheel: false
          };

          $splide_breakpoints = {
            1200: {
              perPage: 1
            },
            992: {
              perPage: 1
            },
            768: {
              perPage: 1
            }
          };
        }

        if ($block.hasClass('video-cards')) {
          $splide_settings = {
            type: 'slide',
            gap: '32px',
            rewind: true,
            pagination: true,
            arrows: true,
            perPage: 3,
            lazyLoad: 'sequential',
            wheel: false
          };

          if ($('.region-content-sidebar').length !== 0) {
            $splide_breakpoints = {
              6000: {
                perPage: 2
              },
              992: {
                perPage: 2
              },
              768: {
                perPage: 1
              }
            };
          }
          else {
            $splide_breakpoints = {
              6000: {
                perPage: 3
              },
              992: {
                perPage: 2
              },
              768: {
                perPage: 1
              }
            };
          }
        }

        // Set splide settings after logic has been applied
        Splide.defaults = $splide_settings;

        // Break point sets all carousels to show one item on screens 768px and smaller
        let $main_carousel = new Splide('#' + $carousel_id, {
          breakpoints: $splide_breakpoints
        });

        $main_carousel.mount();
      }

      // Grab all splide carousels and initialize
      $spide_carousels_default.once('splide-initialize').each(function(index) {
        create_carousel_default($(this), index);
      });
    }
  };
})(jQuery, Drupal, once);
